import { type StaticImageData } from "next/image";

const OPTIMIZED_ASSETS_HOSTNAME = process.env.NEXT_PUBLIC_OPTIMIZED_ASSETS_HOSTNAME;
const UNOPTIMIZED_ASSETS_HOSTNAME = process.env.NEXT_PUBLIC_UNOPTIMIZED_ASSETS_HOSTNAME;

export const isUnoptimizedImageUrl = (url: string) =>
  !!UNOPTIMIZED_ASSETS_HOSTNAME && !!url && url.includes(UNOPTIMIZED_ASSETS_HOSTNAME);

export function getOptimizedImageUrl(
  url: string,
  width?: number,
  height?: number,
  quality?: number,
): string;

export function getOptimizedImageUrl(
  url: StaticImageData,
  width?: number,
  height?: number,
  quality?: number,
): StaticImageData;

export function getOptimizedImageUrl(
  url: string | StaticImageData,
  width?: number,
  height?: number,
  quality?: number,
): string | StaticImageData {
  const isSrcObject = typeof url === "object";
  const imageSrc = isSrcObject ? url?.src : url;

  if (!isUnoptimizedImageUrl(imageSrc) || !OPTIMIZED_ASSETS_HOSTNAME) {
    return isSrcObject ? url : imageSrc;
  }

  try {
    // Handle protocol-relative URLs (starting with //)
    const normalizedSrc = imageSrc.startsWith("//") ? `https:${imageSrc}` : imageSrc;
    const imageLoaderUrl = new URL(normalizedSrc);
    imageLoaderUrl.hostname = OPTIMIZED_ASSETS_HOSTNAME;
    if (width) {
      imageLoaderUrl.searchParams.set("w", String(width));
    }
    if (height) {
      imageLoaderUrl.searchParams.set("h", String(height));
    }
    if (quality) {
      imageLoaderUrl.searchParams.set("q", String(quality));
    }
    const newUrl = imageLoaderUrl.toString();
    return isSrcObject ? { ...url, src: newUrl } : newUrl;
  } catch (error) {
    // If URL parsing fails (e.g., relative URL, malformed URL), return original
    return isSrcObject ? url : imageSrc;
  }
}
